import { render, staticRenderFns } from "./Bact_EachID.vue?vue&type=template&id=28b3b258&scoped=true"
import script from "./Bact_EachID.vue?vue&type=script&lang=js"
export * from "./Bact_EachID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3b258",
  null
  
)

export default component.exports